import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Divider } from '@mui/material';
import Tab from 'components/Common/Tab';
import BusinessDetailsScreen from './BusinessDetailsScreen';
import SecretKeySetting from 'pages/Dashboard/SecretKeySetting';
import { isMerchant } from 'utils/helpers';
import AccountDetailScreen from './AccountDetailScreen';
import StoredPaymentTokens from './StoredPaymentTokens';

const StyledContainer = styled.div({
    backgroundColor: '#F2F2F6',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
});

const StyledActionContainer = styled.div({
    width: '100%',
    marginBottom: 16,
    padding: 22,
    boxSizing: 'border-box',
});

const StyledInnerContainer = styled.div({
    backgroundColor: 'white',
    marginTop: 10,
    borderRadius: 8,
});

const MyAccount: React.FC = () => {
    const isBusiness = isMerchant();
    const intialTabValue = isBusiness ? 'businessDetail' : 'accountDetails';
    const [tab, setTabValue] = useState<string>(intialTabValue);

    const content = () => {
        if (tab === 'businessDetail') {
            return <BusinessDetailsScreen />;
        } else if (tab === 'secretkey') {
            return <SecretKeySetting />;
        } else if (tab === 'accountDetails' && !isBusiness) {
            return <AccountDetailScreen />;
        } else if (tab === 'storedPaymentTokens') {
            return <StoredPaymentTokens />;
        }
    };
    const tabsListConfig = [
        { value: 'accountDetails', label: 'Account Details', hideTab: isBusiness },
        { value: 'businessDetail', label: 'Business Details' },
        { value: 'secretkey', label: 'E-commerce', hideTab: !isBusiness },
        { value: 'storedPaymentTokens', label: 'Stored Payment Tokens'},
    ];
    const visibleTabs = tabsListConfig.filter((tab) => !tab.hideTab);
    return (
        <StyledContainer>
            <StyledActionContainer>
                <StyledInnerContainer>
                    <Tab tabs={visibleTabs} tabValue={tab} setTabValue={setTabValue} />
                    <Divider />
                    {content()}
                </StyledInnerContainer>
            </StyledActionContainer>
        </StyledContainer>
    );
};

export default MyAccount;
